import { NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { BottomNavComponent } from './Navigation/bottom-nav/bottom-nav.component';
import { LoginComponent } from './Authentication/login/login.component';
import { NavbarComponent } from './Navigation/navbar/navbar.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { EditorModule } from 'primeng/editor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JwtModule, JwtHelperService } from '@auth0/angular-jwt';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UnauthorizedComponent } from './Components/unauthorized/unauthorized.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AdmindashBoardComponent } from './Admin/admindash-board/admindash-board.component';
import { AdminNavComponent } from './Admin/admin-nav/admin-nav.component';
import { AddUserComponent } from './Admin/Users/add-user/add-user.component';
import { AdminVeticalSidebarComponent } from './Admin/admin-vetical-sidebar/admin-vetical-sidebar.component';
import { CalendarModule } from 'primeng/calendar';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AuthInterceptor } from './auth.interceptor';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ApiInterceptor } from './api-interceptor.service';
import { SkeletonModule } from 'primeng/skeleton';
import { SpeedDialModule } from 'primeng/speeddial';
import { TimelineModule } from 'primeng/timeline';
import { Add404Component } from './Navigation/add404/add404.component';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { MenuModule } from 'primeng/menu';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { ImageUploadService } from './Services/image-upload.service';
import { ChartModule } from 'primeng/chart';
import { TableModule } from 'primeng/table';
import { RegisterUserComponent } from './Authentication/register-user/register-user.component';
import { ShowAllUsersComponent } from './Admin/Users/show-all-users/show-all-users.component';
import { ShowuserDetailComponent } from './Admin/Users/showuser-detail/showuser-detail.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { LandingPageComponent } from './Components/landing-page/landing-page.component';
import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';
import { FormSpinnerComponent } from './Spinners/form-spinner/form-spinner.component';
import { CardSpinnerComponent } from './Spinners/card-spinner/card-spinner.component';
import { AdminDashSpinnerComponent } from './Spinners/admin-dash-spinner/admin-dash-spinner.component';
import { BlogPostSpinnnerComponent } from './Spinners/blog-post-spinnner/blog-post-spinnner.component';
import { BlogPostDetailSpinnerComponent } from './Spinners/blog-post-detail-spinner/blog-post-detail-spinner.component';
import { ResetPasswordComponent } from './Authentication/reset-password/reset-password.component';
import { NewPasswordComponent } from './Authentication/new-password/new-password.component';
import { ConfirmEmailComponent } from './Authentication/confirm-email/confirm-email.component';
import { ButtonModule } from 'primeng/button';
import { TemplatesComponent } from './Components/templates/templates.component';
import { Theme4Component } from './LinktreeThemes/theme4/theme4.component';
import { RichTextEditorService } from './Services/rich-text-editor.service';
import { HeaderSpinnerComponent } from './Spinners/header-spinner/header-spinner.component';
import { RichTexteditorComponent } from './Components/rich-texteditor/rich-texteditor.component';
import { LinktreDashBoardComponent } from './User/linktre-dash-board/linktre-dash-board.component';
import { MobileViewThemeComponent } from './User/mobile-view-theme/mobile-view-theme.component';
import { ProfileComponent } from './User/profile/profile.component';
import { LinktreeProfileComponent } from './User/linktree-profile/linktree-profile.component';
import { LinktreeAnalyticsComponent } from './User/linktree-analytics/linktree-analytics.component';
import { LinktreeSettingComponent } from './User/linktree-setting/linktree-setting.component';
import { LinktreeTopComponent } from './User/linktree-top/linktree-top.component';
import { AdminNavSpinnerComponent } from './Spinners/admin-nav-spinner/admin-nav-spinner.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TopLinksComponent } from './User/Analytics/top-links/top-links.component';
import { ActivityComponent } from './User/Analytics/activity/activity.component';
import { TopLocationsComponent } from './User/Analytics/top-locations/top-locations.component';
import { TopRferesComponent } from './User/Analytics/top-rferes/top-rferes.component';
import { TopDevicesComponent } from './User/Analytics/top-devices/top-devices.component';
import { TopSocialIconsComponent } from './User/Analytics/top-social-icons/top-social-icons.component';
import { TopBrowsersComponent } from './User/Analytics/top-browsers/top-browsers.component';
import { TopProfileViewComponent } from './User/Analytics/top-profile-view/top-profile-view.component';
import { AccountSettingComponent } from './User/account-setting/account-setting.component';
import { OnlyAdminNavigationComponent } from './Admin/only-admin-navigation/only-admin-navigation.component';
import { AddBlogPostComponent } from './Web/Blog/add-blog-post/add-blog-post.component';
import { BlogPostDetailComponent } from './Web/Blog/blog-post-detail/blog-post-detail.component';
import { BlogPostsComponent } from './Web/Blog/blog-posts/blog-posts.component';
import { ShowBlogPostComponent } from './Web/Blog/show-blog-post/show-blog-post.component';
import { AddContactComponent } from './Web/Pages/add-contact/add-contact.component';
import { AddPageComponent } from './Web/Pages/add-page/add-page.component';
import { PageDetailComponent } from './Web/Pages/page-detail/page-detail.component';
import { ShowContactsComponent } from './Web/Pages/show-contacts/show-contacts.component';
import { ShowPagesComponent } from './Web/Pages/show-pages/show-pages.component';
import { LogsApplicationComponent } from './Admin/logs-application/logs-application.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { FooterComponent } from './Components/footer/footer.component';
import { LockScreenComponent } from './Authentication/lock-screen/lock-screen.component';
import { QrCodeComponent } from './Users/qr-code/qr-code.component';
import { NewProvidersComponent } from './Admin/new-providers/new-providers.component';
import { NewsDetailComponent } from './Administrator/news-detail/news-detail.component';
import { AdditonalLandingPageComponent } from './Components/additonal-landing-page/additonal-landing-page.component';
import { HeaderComponent } from './Components/header/header.component';
import { ContactUsComponent } from './Pages/contact-us/contact-us.component';
import { NotificationsComponent } from './Admin/Notifications/Notifications.component';
import { BusinessInsightDashboardComponent } from './BusinessInsights/business-insight-dashboard/business-insight-dashboard.component';
import { EnsightsComponent } from './BusinessInsights/ensights/ensights.component';
import { EnsightsDetailsComponent } from './BusinessInsights/ensights-details/ensights-details.component';
import { CommingSoonComponent } from './Components/comming-soon/comming-soon.component';
import { AdminComminSoonComponent } from './Components/admin-commin-soon/admin-commin-soon.component';
import { EconomicChatComponent } from './OpenAPI/economic-chat/economic-chat.component';
import { LifetimeAnalyticsComponent } from './User/Analytics/lifetime-analytics/lifetime-analytics..component';
import { GetUserIntersetsComponent } from './User/get-user-intersets/get-user-intersets.component';
import { MarkdownModule } from 'ngx-markdown';
import { UserInterestNewsComponent } from './User/user-interest-news/user-interest-news.component';
import { AuthService } from './Services/auth.service';
import { SafeAreaDirective } from './safe-area.directive';
import { UsercontactsComponent } from './User/usercontacts/usercontacts.component';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { SocialLoginService } from './Services/social-login.service';
import { environmentFire } from '../Environment';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFireModule } from '@angular/fire/compat';
import { InputOtpModule } from 'primeng/inputotp';
import { MainMenuPageMobieComponent } from './Mobile/main-menu-page-mobie/main-menu-page-mobie.component';
import { SpeedDial } from 'primeng/speeddial';
import { NewsTypesWindowComponent } from './Mobile/news-types-window/news-types-window.component';
import { BusinessLeadsComponent } from './AISections/business-leads/business-leads.component';
import { NetworkingSuggectionsComponent } from './AISections/networking-suggections/networking-suggections.component';
import { MarketTrendsComponent } from './AISections/market-trends/market-trends.component';
import { CompetitiveIntegenceComponent } from './AISections/competitive-integence/competitive-integence.component';
import { AIFilteredNewsAlertsComponent } from './AISections/ai-filtered-news-alerts/ai-filtered-news-alerts.component';
import { TailoredBusinessOpportunitiesComponent } from './AISections/tailored-business-opportunities/tailored-business-opportunities.component';
import { BusinessInsightsComponent } from './AISections/business-insights/business-insights.component';
import { ImageModule } from 'primeng/image';
import { HomepageAPPComponent } from './Components/homepage-app/homepage-app.component';
import { EmailSetupPageComponent } from './Users/email-setup-page/email-setup-page.component';
import { TypingComponentComponent } from './Components/typing-component/typing-component.component';
import { Router } from '@angular/router';
import { NoContentFoundComponent } from './Components/no-content-found/no-content-found.component';
import { TranslationService } from './Services/translation.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SettingComponent } from './User/setting/setting.component';
import { DrawerModule } from 'primeng/drawer';
import { DeleteMyAccountComponent } from './User/delete-my-account/delete-my-account.component';
import { ButtonSpinnerComponent } from './Components/button-spinner/button-spinner.component';
import { CombineNavMobileComponent } from './Navigation/combine-nav-mobile/combine-nav-mobile.component';
import { BlogNavPageComponent } from './Navigation/blog-nav-page/blog-nav-page.component';
import { PagesNavPageComponent } from './Navigation/pages-nav-page/pages-nav-page.component';
import { UsersNavPageComponent } from './Navigation/users-nav-page/users-nav-page.component';
import { UserInterestManuComponent } from './Navigation/user-interest-manu/user-interest-manu.component';
import { SiteSettingComponent } from './Navigation/site-setting/site-setting.component';

export function tokenGetter(authService: AuthService) {
  return authService.getToken(); // Get token synchronously
}
// Function to set up translation file loader
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    BottomNavComponent,
    LoginComponent,
    NavbarComponent,
    UnauthorizedComponent,
    AdmindashBoardComponent,
    AdminNavComponent,
    AddUserComponent,
    AdminVeticalSidebarComponent,
    Add404Component,
    RegisterUserComponent,
    ShowAllUsersComponent,
    ShowuserDetailComponent,
    LandingPageComponent,
    FormSpinnerComponent,
    CardSpinnerComponent,
    AdminDashSpinnerComponent,
    BlogPostSpinnnerComponent,
    BlogPostDetailSpinnerComponent,
    ResetPasswordComponent,
    NewPasswordComponent,
    ConfirmEmailComponent,
    TemplatesComponent,
    Theme4Component,
    HeaderSpinnerComponent,
    RichTexteditorComponent,
    LinktreDashBoardComponent,
    MobileViewThemeComponent,
    ProfileComponent,
    LinktreeProfileComponent,
    LinktreeAnalyticsComponent,
    LinktreeSettingComponent,
    LinktreeTopComponent,
    AdminNavSpinnerComponent,
    LifetimeAnalyticsComponent,
    TopLinksComponent,
    ActivityComponent,
    TopLocationsComponent,
    TopRferesComponent,
    TopDevicesComponent,
    TopSocialIconsComponent,
    TopBrowsersComponent,
    TopProfileViewComponent,
    AccountSettingComponent,
    OnlyAdminNavigationComponent,
    AddBlogPostComponent,
    ShowBlogPostComponent,
    BlogPostDetailComponent,
    BlogPostsComponent,
    AddPageComponent,
    ShowPagesComponent,
    PageDetailComponent,
    AddContactComponent,
    ShowContactsComponent,
    LogsApplicationComponent,
    FooterComponent,
    LockScreenComponent,
    BottomNavComponent,
    QrCodeComponent,
    NewProvidersComponent,
    NewsDetailComponent,
    AdditonalLandingPageComponent,
    HeaderComponent,
    ContactUsComponent,
    NotificationsComponent,
    BusinessInsightDashboardComponent,
    EnsightsComponent,
    EnsightsDetailsComponent,
    CommingSoonComponent,
    AdminComminSoonComponent,
    EconomicChatComponent,
    GetUserIntersetsComponent,
    UserInterestNewsComponent,
    SafeAreaDirective,
    UsercontactsComponent,
    MainMenuPageMobieComponent,
    NewsTypesWindowComponent,
    BusinessLeadsComponent,
    NetworkingSuggectionsComponent,
    MarketTrendsComponent,
    CompetitiveIntegenceComponent,
    AIFilteredNewsAlertsComponent,
    TailoredBusinessOpportunitiesComponent,
    BusinessInsightsComponent,
    HomepageAPPComponent,
    EmailSetupPageComponent,
    TypingComponentComponent,
    NoContentFoundComponent,
    SettingComponent,
    DeleteMyAccountComponent,
    ButtonSpinnerComponent,
    CombineNavMobileComponent,
    BlogNavPageComponent,
    PagesNavPageComponent,
    UsersNavPageComponent,
    UserInterestManuComponent,
    SiteSettingComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CKEditorModule,
    FormsModule,
    ReactiveFormsModule,
    EditorModule,
    ProgressSpinnerModule,
    ToastModule,
    BrowserAnimationsModule,
    CalendarModule,
    ConfirmDialogModule,
    DialogModule,
    BreadcrumbModule,
    SkeletonModule,
    SpeedDialModule,
    TimelineModule,
    OrganizationChartModule,
    MenuModule,
    TieredMenuModule,
    ChartModule,
    AutoCompleteModule,
    DropdownModule,
    SidebarModule,
    ButtonModule,
    DividerModule,
    NgApexchartsModule,
    TableModule,
    ScrollPanelModule,
    QRCodeComponent,
    MarkdownModule.forRoot(),
    InputOtpModule,
    SpeedDial,
    FormsModule,
    EditorModule,
    DrawerModule,
    AngularFireModule.initializeApp(environmentFire.firebase), // ✅ Old compat way
    AngularFireAuthModule,
    ImageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: () => tokenGetter(new AuthService(new JwtHelperService(), new Router())),
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  providers: [
    provideAnimationsAsync(),
    TranslationService,
    ConfirmationService,
    providePrimeNG({
      theme: {
        preset: Aura
      }
    }),
    provideFirebaseApp(() => initializeApp(environmentFire.firebase)),
    provideAuth(() => getAuth()), 
    JwtHelperService,
    MessageService,
    AuthService,
    SocialLoginService,
    RichTextEditorService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    ImageUploadService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
